<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path d="M14 14L25.9985 25.9985" stroke="#FFF" />
    <path d="M26 14L14.0015 25.9985" stroke="#FFF" />
</svg>
